import { lazy } from 'react';

import Loadable, { LoadingSpinner as Loading } from '@comeon/loadable';

export const AccountMenu = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account" */
			'./account-menu'
		),
	loading: Loading
});

export const AccountWithdraw = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-withdraw" */
			'./account-withdraw'
		),
	loading: Loading
});

export const AccountDeposit = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-deposit" */
			'./account-deposit'
		),
	loading: Loading
});

export const AccountRealityCheckSetTimeLimit = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-reality-check-set-time-limit" */
			'./account-reality-check-set-time-limit'
		),
	loading: Loading
});

export const AccountSettings = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-settings-gateway" */
			'./account-settings/gateway'
		),
	loading: Loading
});

export const AccountUpload = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "upload-documents" */
			'./upload-documents/upload-documents'
		),
	loading: Loading
});

export const AccountDepositNativeInterceptor = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "deposit-native-interceptor" */
			'./account-menu/deposit-native-interceptor'
		),
	loading: Loading
});

export const AccountSettingsEmail = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-settings-email" */
			'./account-settings/email'
		),
	loading: Loading
});

export const PlayerLimitsActivityGateway = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-limits-activity" */
			'./limits-activity/gateway'
		),
	loading: Loading
});

export const RiskProfile = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "risk-profile" */
			'./risk-profile'
		),
	loading: Loading
});

export const GamingHabits = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "gaming-habits" */
			'./risk-profile/gaming-habits'
		),
	loading: Loading
});

export const PlayerBehavior = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-behavior" */
			'./risk-profile/gaming-habits/player-behavior'
		),
	loading: Loading
});

export const GameTypes = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-behavior" */
			'./risk-profile/gaming-habits/game-types/game-types'
		),
	loading: Loading
});

export const SelfAssessmentResult = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-behavior" */
			'./risk-profile/gaming-habits/self-assessment-result/self-assessment-result'
		),
	loading: Loading
});

export const SelfAssessment = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-behavior" */
			'./risk-profile/gaming-habits/self-assessment/self-assessment'
		),
	loading: Loading
});

export const MessagesMentorWrapper = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-behavior" */
			'./risk-profile/gaming-habits/messages-mentor/mentor-messages-container'
		),
	loading: Loading
});

export const SourceOfWealth = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./source-of-wealth'
		),
	loading: Loading
});

export const WebPushBackdoor = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./web-push-backdoor'
		),
	loading: Loading
});

export const TransactionHistory = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-transaction-history" */
			'./transaction-history'
		),
	loading: Loading
});

export const AccountBonusCode = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-bonus-code" */
			'./account-bonus-code'
		),
	loading: Loading
});

export const AccountSettingsMobile = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-settings-mobile" */
			'./mobile-phone-verification/account-settings-mobile'
		),
	loading: Loading
});

export const MyActivities = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-my-activities" */
			'./my-activities/my-activities-container'
		),
	loading: Loading
});

export const RealityCheck = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "reality-check" */
			'./reality-check'
		),
	loading: Loading
});

export const TimeLimit = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "time-limit" */
			'./time-limit'
		),
	loading: Loading
});

export const MentorMessage = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "mentor-message" */
			'./mentor-message'
		),
	loading: Loading
});

export const MyNotifications = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./my-notifications/my-notifications.js'
		),
	loading: Loading
});

export const ServerNotificationListener = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./my-notifications/my-notification-listener.js'
		),
	loading: Loading
});

export const MyNotificationSlider = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./my-notifications/slider/my-notification-slider-container.js'
		),
	loading: Loading
});

export const MyNotificationAdditionalDataPopup = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./my-notifications/slider/my-notification-additional-data-popup.js'
		),
	loading: Loading
});

export const MyNotificationBluebar = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-notifications" */
			'./my-notifications/bluebar/my-notification-bluebar.js'
		),
	loading: Loading
});

export const DepositLimits = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "deposit-limits" */
			'./limits/deposit'
		),
	loading: Loading
});

export const WelcomeScreen = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "welcome-screen" */
			'./welcome/welcome-screen'
		),
	loading: Loading
});

export const AccountSettingsMobileEnterCodeV2 = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "account-settings-mobile-enter-code" */
			'./mobile-phone-verification/account-settings-mobile-enter-code-v2'
		),
	loading: Loading
});

export const NextSessionTimer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "next-session-timer" */
			'./time-limit/next-session-timer'
		),
	loading: Loading
});

export const ProductSwitch = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "product-switch" */
			'./product-switch/product-switch-container'
		),
	loading: Loading
});

export const PlayerInfoScreen = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "player-info-screen" */
			'./welcome/player-info-screen'
		),
	loading: Loading
});

export const WelcomeScreenPopUp = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "welcome-screen-popup" */
			'./welcome/welcome-screen-popup'
		),
	loading: Loading
});

export const LimitsSummaryScreenPopUp = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "welcome-screen-popup" */
			'./welcome/popup'
		),
	loading: Loading
});

export const RenderLimitsContent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "my-limits" */
			'./limits/render-content'
		),
	loading: Loading
});

export const TemporaryAccountVerifications = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "temp-verifications" */
			'./temp-verifications'
		),
	loading: Loading
});

export const ResponsibleGamingLimits = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "responsible-gaming-limits" */
			'./responsible-gaming-limit'
		),
	loading: Loading
});

export const AccountResponsibleGaming = Loadable({
	loader: () => import(/* webpackChunkName: "account-res-gaming" */ './limits/responsible-gaming'),
	loading: Loading
});

export const ActivityTimer = lazy(() => import('./timers/activity-timer'));

export const ActiveProducts = lazy(() => import('./active-products'));

export const CombinedLimits = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "combined-limits" */
			'./limits/combined-limits'
		),
	loading: Loading
});

export default null;
